module.exports = __webpack_public_path__ + "img/return-message.83fad1df.png";